import avatar from "../assets/img/bot.png";
import user from "../assets/img/user.png";
const BotAvatar = () => {
  return (
    <div className="react-chatbot-kit-chat-bot-avatar">
      <img
        src={avatar}
        alt="Bot Avatar"
        style={{ width: "100%", height: "100%", maxHeight: "40px", borderRadius: "50%" }}
      />
    </div>
  );
};

export const UserAvatar = () => {
  return (
    <div className="react-chatbot-kit-chat-bot-avatar">
      <img
        src={user}
        alt="User Avatar"
        style={{ width: "100%", height: "100%", maxHeight: "40px", borderRadius: "50%" }}
      />
    </div>
  );
};

export default BotAvatar;
